import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ErrorType } from "../../../types";
import { useToast } from "../../../components/ui/use-toast";
import { addPatient } from "../../../services/patients";
import { useAuth } from "../../../contexts/auth-context";

export function useAddPatient() {
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const { mobile } = useAuth();
  const { mutate, isPending } = useMutation({
    mutationFn: addPatient,
    onSuccess: () => {
      if (mobile) {
        queryClient.invalidateQueries({ queryKey: ["patients", mobile] });
      }
    },
    onError: (error: ErrorType) =>
      toast({
        title: "Reached maximum limit to add patients.",
        description: error.response.data.description,
        variant: "destructive",
      }),
  });

  return { addPatient: mutate, isPending };
}